import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";
import InputForm from "../../../../components/input/input-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({setFilters, filters, boName}) => {
    const { creatorsOptions, evaluatorsOptions } = useFetchOptions()

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label={filters.boId === '' ? "Data/hora inicial *" : "Data/hora inicial"}
                        selected={filters.dtStart ? new Date(filters.dtStart) : null}
                        onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label={filters.boId === '' ? "Data/hora final *" : "Data/hora final"}
                        selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                        onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label='Cadastrado por'
                        isMulti={true}
                        wrapValues={true}
                        options={creatorsOptions}
                        value={filters.creators}
                        onChange={(value) => setFilters(prev => ({...prev, creators: value}))}
                        instanceId="creators"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Avaliado por'
                        isMulti={true}
                        wrapValues={true}
                        options={evaluatorsOptions}
                        value={filters.evaluators}
                        onChange={(value) => setFilters(prev => ({...prev, evaluators: value}))}
                        instanceId="evaluators"
                        classNameWrapper={"w-full"}
                    />

                    <InputForm
                        label={`Número do ${boName}`}
                        value={filters.boId}
                        onChange={({target}) => setFilters(prev => ({ ...prev, boId: target.value }))}
                        instanceId="boId"
                        id="boId"
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;